import Handlebars from 'handlebars';
import AMApp from '../../global/app';

/**
 * Dividend Module (Plain JS)
 */
export default class Dividend {
  constructor(element, options = {}) {
    this.element = element;
    this.amApp = new AMApp();

    this.settings = {
      routeFondsDividendData: AMApp.langGetParam + 'eID=fonds&function=listFilesByFonds&wkn=',
      ...options
    };

    const templateEl = document.getElementById('dividend_data_template');
    this.dividendResultRaw = templateEl ? templateEl.innerHTML : '';
    this.dividendResultTarget = document.getElementById('fonds_brochures_result_target');

    this.statusInit = this.element.querySelectorAll('.js_status_init');
    this.statusNoResult = this.element.querySelectorAll('.js_status_noresult');
    this.statusErrorClass = 'js_status_error';

    this.fondsSearchInput = this.element.querySelector('.kesearchbox input');

    this.init();
  }

  init() {
    console.log('### Dividend ###');
    this.populateDropdownYear();

    // Event Delegation für Klicks auf WKN-Elemente
    this.element.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-wkn]');
      if (trigger) {
        event.preventDefault();
        const wkn = trigger.dataset.wkn;
        const name = trigger.dataset.name;

        this.getDividendData(wkn);

        if (this.fondsSearchInput) {
          this.fondsSearchInput.value = name || '';
        }
      }
    });
  }

  /**
   * Fetch dividend data
   * @param {string} wkn
   */
  async getDividendData(wkn) {
    this.statusIsLoading();

    const url = AMApp.basePath + this.settings.routeFondsDividendData + encodeURIComponent(wkn);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const result = await response.json();

      this.success(result);
    } catch (error) {
      this.fail(error);
    }
  }

  success(response) {
    if (response && response.length > 0) {
      this.renderDividendData(response);
    } else {
      this.statusNoData();
    }
  }

  fail(error) {
    console.error('Dividend Fetch Error:', error);
    this.removeLoader();
    this.showFailMessage();
  }

  renderDividendData(data) {
    if (data) {
      this.statusDataFound();
      if (this.dividendResultRaw && this.dividendResultTarget) {
        const compiledTemplate = Handlebars.compile(this.amApp.toHandlebarsDelimiters(this.dividendResultRaw));
        // Erwartet laut Original das erste Element des Arrays
        this.dividendResultTarget.innerHTML = compiledTemplate(data[0]);
      }
    } else {
      this.statusNoData();
    }
  }

  statusIsLoading() {
    if (this.dividendResultTarget) this.dividendResultTarget.style.display = 'none';

    if (this.statusInit.length > 0) {
      this.statusInit[0].insertAdjacentHTML('beforebegin', AMApp.LOADING_ANIMATION);
    }

    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, true);

    // Alte Fehlermeldungen entfernen
    this.element.querySelectorAll('.' + this.statusErrorClass).forEach(el => el.remove());

    if (window.innerWidth <= AMApp.CONSTANTS.BREAKPOINT.LG) {
      const loader = this.element.querySelector('.loader');
      if (loader) {
        window.scrollTo({
          top: loader.getBoundingClientRect().top + window.scrollY,
          behavior: 'smooth'
        });
      }
    }
  }

  statusNoData() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, false);
    if (this.dividendResultTarget) this.dividendResultTarget.style.display = 'none';
    this.removeLoader();
  }

  statusDataFound() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, true);
    if (this.dividendResultTarget) this.dividendResultTarget.style.display = '';
    this.removeLoader();
  }

  showFailMessage() {
    const message = AMApp.translations.response.fail;
    const p = document.createElement('p');
    p.className = `result-status ${this.statusErrorClass}`;
    p.textContent = message;

    if (this.dividendResultTarget) {
      this.dividendResultTarget.after(p);
    }
  }

  toggleStatusElements(elements, shouldHide) {
    elements.forEach(el => el.classList.toggle('d-none', shouldHide));
  }

  removeLoader() {
    this.element.querySelectorAll('.loader').forEach(loader => loader.remove());
  }

  populateDropdownYear() {
    const yearSelect = document.getElementById('year');
    if (!yearSelect) return;

    const firstYear = 1998;
    const currentYear = new Date().getFullYear();
    let optionsHtml = '';

    for (let year = firstYear; year <= currentYear; year++) {
      optionsHtml += `<option value="${year}">${year}</option>`;
    }

    yearSelect.insertAdjacentHTML('beforeend', optionsHtml);
  }
}